import React from 'react'
import { Route, Routes } from 'react-router-dom'
import PrivateRoute7  from '../../app/routes/PrivateRoute7'

import EditModuleConfigurations from './EditModuleConfigurations'
import ListModuleConfigurations from './ListModuleConfigurations'
import NewModuleConfigurations from './NewModuleConfigurations'

const AdminModuleConfigurationsRoutes = () => {
  return (
    <Routes>
        <Route path="/" element={<PrivateRoute7><ListModuleConfigurations /></PrivateRoute7>} />
        <Route path="edit-module-configuration" element={<PrivateRoute7><EditModuleConfigurations /></PrivateRoute7>} />
        <Route path="new-module-configuration" element={<PrivateRoute7><NewModuleConfigurations /></PrivateRoute7>} />
    </Routes>
  )
}

export default AdminModuleConfigurationsRoutes